import React from 'react';
import ActiveLink from '../Header/ActiveLink/ActiveLink';
import styles from './launchNewServices.module.scss';

export interface CrumbProps {
    url: string;
    name: string;
}

export interface BreadcrumbsProps {
    crumbs: CrumbProps[];
}

const LaunchNewServicesComponent = ({ crumbs }: BreadcrumbsProps) => {
    return (
        <section className={styles.serviceAnnounce} data-screen-label="Energy announcement">
            <div className="container">
                <div className={styles.serviceAnnounceInner}>
                    <span className={styles.serviceAnnounceTag} data-no="Nytt">
                        New
                    </span>
                    <div className={styles.serviceAnnounceCopy}>
                        <h3 data-no="Konsulenttjenester for energisektoren">
                            Consultancy services for the energy sector
                        </h3>
                        <p data-no="Vi hjelper energiselskaper med å håndtere endring, styrke driften og gjøre komplekse utfordringer om til praktiske løsninger.">
                            We help energy companies navigate change, strengthen operations and turn
                            complex challenges into practical solutions.
                        </p>
                    </div>
                    <ActiveLink className={styles.serviceAnnounceLink} href="/energy">
                        Explore energy services <span className="arrow">➔</span>
                    </ActiveLink>
                </div>
            </div>
        </section>
    );
};

export default LaunchNewServicesComponent;
